<mat-toolbar>
    <button *ngIf="backUrl" mat-icon-button color="primary" [routerLink]="backUrl" aria-label="back button">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <span>{{title}}</span>
    <span class="vedrax-toolbar-remaining-space"></span>
    <button *ngIf="createAction" mat-raised-button color="primary" (click)="create()">{{createAction.label}}</button>
</mat-toolbar>

<div class="alert alert-info m-t-15 m-b-15" *ngIf="description">
    {{description}}
</div>

<vedrax-table [descriptor]="tableDescriptor" (onSelect)="select($event)"></vedrax-table>